import { createContext } from "react";

export const EducationContext = createContext([]);
